import React from 'react';
import { Card, Avatar, Row, Col } from 'antd';
import { BellOutlined, DislikeFilled, InfoOutlined, LikeFilled } from '@ant-design/icons';

import { notificationContentGenerator } from 'helpers/notificationContent';
import { NotificationActionType } from 'helpers/getNotificationsActionTypes';
import { t } from 'i18next';
import { useAutoApprovalContext } from 'store/AutoApprovalContext';
interface NotificationCardProps {
	type: string;
	notification: NotificationActionType;
	properties: any;
	timestamp: string;
}
enum NotificationAction {
	INFO = 'INFO',
	WARNING = 'WARNING',
	ACTION = 'ACTION',
}
const NotificationCard: React.FC<NotificationCardProps> = ({ type, notification, properties, timestamp }) => {
	const { isAutoApproval } = useAutoApprovalContext();
	return (
		<Card className='notification-card' style={{ width: '300px' }}>
			<Row align='middle' className='notification-content'>
				<Col span={4}>
					<div className='avatar-container'>
						<Avatar>Ai</Avatar>
						{type === NotificationAction.ACTION ? (
							<div className='notifications-feed-avatar-badge notifications-feed-green-badge'>
								<BellOutlined size={0.05} />
							</div>
						) : type === NotificationAction.WARNING ? (
							<div className='notifications-feed-avatar-badge notifications-feed-warning-badge'>
								<InfoOutlined size={0.05} />
							</div>
						) : (
							<></>
						)}
					</div>
				</Col>
				<Col span={20}>
					{notification.includes('REVIEW') ? (
						<p className='my-0 py-0 font-semi-bold'>
							{t('merchantNewReview')}{' '}
							{properties.like === 'true' ? (
								<LikeFilled className='pr-2' style={{ color: '#4caf50', fontSize: '1rem', fontWeight: 'bold' }} />
							) : (
								<DislikeFilled className='pr-2' style={{ color: '#cf1322', fontSize: '1rem' }} />
							)}
						</p>
					) : (
						<></>
					)}
					<p className='notification-message font-medium'>
						{notificationContentGenerator(notification, { ...properties, isAutoApproval })}
					</p>
					<p className='notification-timestamp'>{timestamp}</p>
				</Col>
			</Row>
		</Card>
	);
};

export default NotificationCard;
